import { __assign, __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from '@mui/material/styles';
import MoaStyledComponent from "../../Style/MoaStyled";
import { Typography } from '../../';
import RadioGroup from '@mui/material/RadioGroup';
import FormControl from '@mui/material/FormControl';
;
var StyledComponent = styled(function (props) {
    var id = props.id, ariaLabel = props.ariaLabel, text = props.text, children = props.children, value = props.value, sx = props.sx, rest = __rest(props, ["id", "ariaLabel", "text", "children", "value", "sx"]);
    if (sx)
        console.error('The sx prop is not used in StyledComponent');
    return (_jsx("div", { id: id, "data-current-value": value, children: _jsxs(FormControl, { "aria-label": "".concat(text, " ").concat(ariaLabel), children: [text && (_jsx("div", { style: { padding: "0.25rem" }, children: _jsx(Typography, { children: text }) })), _jsx(RadioGroup, __assign({ value: value }, rest, { style: { paddingLeft: text ? "0.5rem" : "0rem" }, children: children }))] }) }));
})(function () { return ({}); });
var ThemedComponent = function (props) { return (_jsx(MoaStyledComponent, { children: _jsx(StyledComponent, __assign({}, props)) })); };
export default ThemedComponent;
